export const SCHEMA_VERSION = 1

export const FIELD_TYPES = [
  { value: 'text-box', label: 'Texto' },
  { value: 'dropdown', label: 'Caixa de seleção' },
  { value: 'checkbox', label: 'Sim/Não' },
  { value: 'date', label: 'Data' },
  { value: 'time', label: 'Hora' },
]

export const RESULTADOS = [
  { value: 'success', label: 'Sucesso' },
  { value: 'fail', label: 'Falha' },
  { value: 'neutral', label: 'Neutro' },
]

export const SIM_NAO = [
  { value: true, label: 'Sim' },
  { value: false, label: 'Não' },
]

export const RESPOSTAS_PADRAO = [
  { label: 'Conforme', result: 'success' },
  { label: 'Não conforme', result: 'fail' },
  { label: 'Não se aplica', result: 'neutral' },
]

export const LIMITES = {
  codigo: 50,
  titulo: 255,
  rotulo: 100,
  nome: 150,
  descricaoItem: 500,
  orientacoes: 1000,
  campos: 30,
  etapas: 20,
  grupos: 30,
  itensPorGrupo: 100,
  itens: 500,
  minOpcoes: 2,
  maxOpcoes: 20,
}

const OBSERVACOES_LABEL = 'Observações'
const OBSERVACAO_ITEM_LABEL = 'Observação'
const CARACTERE_NAO_SUPORTADO = /[\uD800-\uDFFF]/

export function gerarId(prefixo) {
  const aleatorio = Math.random().toString(36).slice(2, 12).padEnd(10, '0')
  return `${prefixo}_${aleatorio}`
}

export function resultadoPadrao(indice) {
  if (indice === 0) return 'success'
  if (indice === 1) return 'fail'
  return 'neutral'
}

export function novaOpcao(label = '', result = null) {
  return result ? { id: gerarId('o'), label, result } : { id: gerarId('o'), label }
}

export function novoCampo() {
  return {
    id: gerarId('f'),
    label: '',
    field_type: 'text-box',
    options: null,
  }
}

export function novoItem(base) {
  if (!base) {
    return {
      id: gerarId('i'),
      item_name: '',
      field_type: 'dropdown',
      options: RESPOSTAS_PADRAO.map(resposta => novaOpcao(resposta.label, resposta.result)),
      success_value: null,
    }
  }

  return {
    id: gerarId('i'),
    item_name: '',
    field_type: base.field_type,
    options: base.options ? base.options.map(opcao => novaOpcao(opcao.label, opcao.result)) : null,
    success_value: base.success_value,
  }
}

export function novoGrupo(base) {
  return { id: gerarId('g'), group_name: '', items: [novoItem(base)] }
}

export function novaEtapa(base) {
  return { id: gerarId('s'), step_name: '', instructions: '', groups: [novoGrupo(base)] }
}

export function novoChecklist(tpId = 0) {
  return {
    id: null,
    tp_id: tpId,
    checklist_code: '',
    title: '',
    reviewed_at: null,
    created_at: null,
    actived: true,
    header: [],
    body: [novaEtapa()],
    observations: { enabled: true, label: OBSERVACOES_LABEL },
    item_observations: { enabled: false, label: OBSERVACAO_ITEM_LABEL },
    footer: [],
  }
}

export function ultimoItem(grupo) {
  return grupo && grupo.items.length ? grupo.items[grupo.items.length - 1] : null
}

export function ultimoItemDaEtapa(etapa) {
  return etapa && etapa.groups.length ? ultimoItem(etapa.groups[etapa.groups.length - 1]) : null
}

export function aplicarMudancaCampo(campo, chave, valor) {
  if (chave === 'field_type') {
    return {
      ...campo,
      field_type: valor,
      options: valor === 'dropdown' ? [novaOpcao(), novaOpcao()] : null,
    }
  }

  return { ...campo, [chave]: valor }
}

export function aplicarMudancaItem(item, chave, valor) {
  if (chave !== 'field_type') return { ...item, [chave]: valor }
  if (valor === item.field_type) return item

  if (valor === 'dropdown') {
    return {
      ...item,
      field_type: valor,
      options: RESPOSTAS_PADRAO.map(resposta => novaOpcao(resposta.label, resposta.result)),
      success_value: null,
    }
  }

  return {
    ...item,
    field_type: valor,
    options: null,
    success_value: valor === 'checkbox' ? true : null,
  }
}

export function duplicarItem(item) {
  return { ...novoItem(item), item_name: item.item_name }
}

export function atualizarCampo(checklist, secao, campoId, atualizar) {
  return {
    ...checklist,
    [secao]: checklist[secao].map(campo => (campo.id === campoId ? atualizar(campo) : campo)),
  }
}

export function atualizarEtapa(checklist, etapaId, atualizar) {
  return {
    ...checklist,
    body: checklist.body.map(etapa => (etapa.id === etapaId ? atualizar(etapa) : etapa)),
  }
}

export function atualizarGrupo(checklist, etapaId, grupoId, atualizar) {
  return atualizarEtapa(checklist, etapaId, etapa => ({
    ...etapa,
    groups: etapa.groups.map(grupo => (grupo.id === grupoId ? atualizar(grupo) : grupo)),
  }))
}

export function atualizarItem(checklist, etapaId, grupoId, itemId, atualizar) {
  return atualizarGrupo(checklist, etapaId, grupoId, grupo => ({
    ...grupo,
    items: grupo.items.map(item => (item.id === itemId ? atualizar(item) : item)),
  }))
}

export function adicionarOpcao(opcoes, comResultado) {
  const lista = opcoes || []
  return [...lista, novaOpcao('', comResultado ? resultadoPadrao(lista.length) : null)]
}

export function alterarOpcao(opcoes, opcaoId, chave, valor) {
  return opcoes.map(opcao => (opcao.id === opcaoId ? { ...opcao, [chave]: valor } : opcao))
}

export function removerOpcao(opcoes, opcaoId) {
  return opcoes.filter(opcao => opcao.id !== opcaoId)
}

export function mover(lista, id, direcao) {
  const origem = lista.findIndex(item => item.id === id)
  const destino = origem + direcao
  if (origem === -1 || destino < 0 || destino >= lista.length) return lista

  const copia = lista.slice()
  const [item] = copia.splice(origem, 1)
  copia.splice(destino, 0, item)
  return copia
}

export function contarItens(checklist) {
  return checklist.body.reduce(
    (total, etapa) =>
      total + etapa.groups.reduce((subtotal, grupo) => subtotal + grupo.items.length, 0),
    0,
  )
}

export function resumoRespostas(item) {
  if (item.field_type === 'dropdown') {
    const labels = (item.options || []).map(opcao => opcao.label).filter(label => !!label)
    return labels.length ? labels.join(' · ') : 'Sem opções de resposta'
  }
  if (item.field_type === 'checkbox') {
    return `Sim / Não (sucesso: ${item.success_value === false ? 'Não' : 'Sim'})`
  }
  return 'Informativo'
}

export function classificarResposta(item, resposta) {
  if (resposta === undefined || resposta === null || resposta === '') return null

  if (item.field_type === 'dropdown') {
    const opcao = (item.options || []).find(o => o.id === resposta)
    return opcao ? opcao.result : null
  }
  if (item.field_type === 'checkbox') return resposta === item.success_value ? 'success' : 'fail'

  return null
}

export function parseData(valor) {
  if (!valor || typeof valor !== 'string') return null

  const [ano, mes, dia] = valor.slice(0, 10).split('-').map(Number)
  if (!ano || !mes || !dia) return null

  return new Date(ano, mes - 1, dia)
}

function parseDataDigitada(valor) {
  const partes = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(valor.trim())
  if (!partes) return null

  const [dia, mes, ano] = partes.slice(1).map(Number)
  const data = new Date(ano, mes - 1, dia)
  const valida = data.getFullYear() === ano && data.getMonth() === mes - 1 && data.getDate() === dia

  return valida ? data : null
}

export function formatarDataPayload(valor) {
  if (!valor) return null
  if (typeof valor === 'string' && !valor.trim()) return null

  const data = valor instanceof Date ? valor : parseDataDigitada(String(valor))
  if (!data || isNaN(data.getTime())) return String(valor)

  const dia = `${data.getDate()}`.padStart(2, '0')
  const mes = `${data.getMonth() + 1}`.padStart(2, '0')
  return `${data.getFullYear()}-${mes}-${dia}`
}

export function formatarDataExibicao(valor) {
  const data = valor instanceof Date ? valor : parseData(valor)
  if (!data) return ''

  const dia = `${data.getDate()}`.padStart(2, '0')
  const mes = `${data.getMonth() + 1}`.padStart(2, '0')
  return `${dia}/${mes}/${data.getFullYear()}`
}

export function formatarDataHoraExibicao(valor) {
  if (!valor) return ''

  const data = new Date(valor)
  if (isNaN(data.getTime())) return ''

  const hora = `${data.getHours()}`.padStart(2, '0')
  const minuto = `${data.getMinutes()}`.padStart(2, '0')
  return `${formatarDataExibicao(data)} ${hora}:${minuto}`
}

function parseObservacoes(observacoes, enabledPadrao, labelPadrao) {
  if (!observacoes) return { enabled: enabledPadrao, label: labelPadrao }

  return {
    enabled: typeof observacoes.enabled === 'boolean' ? observacoes.enabled : enabledPadrao,
    label: observacoes.label || labelPadrao,
  }
}

export function parseChecklist(doc) {
  return {
    id: doc.id || null,
    tp_id: doc.tp_id,
    checklist_code: doc.checklist_code || '',
    title: doc.title || '',
    reviewed_at: parseData(doc.reviewed_at),
    created_at: doc.created_at || null,
    actived: !!doc.actived,
    header: doc.header || [],
    body: (doc.body || []).map(etapa => ({ ...etapa, instructions: etapa.instructions || '' })),
    observations: parseObservacoes(doc.observations, true, OBSERVACOES_LABEL),
    item_observations: parseObservacoes(doc.item_observations, false, OBSERVACAO_ITEM_LABEL),
    footer: doc.footer || [],
  }
}

function limparTexto(valor) {
  return typeof valor === 'string' ? valor.replace(/\s+/g, ' ').trim() : ''
}

function montarOpcoes(opcoes, comResultado) {
  return (opcoes || []).map(opcao =>
    comResultado
      ? { id: opcao.id, label: limparTexto(opcao.label), result: opcao.result || null }
      : { id: opcao.id, label: limparTexto(opcao.label) },
  )
}

function montarCampo(campo) {
  return {
    id: campo.id,
    label: limparTexto(campo.label),
    field_type: campo.field_type,
    options: campo.field_type === 'dropdown' ? montarOpcoes(campo.options, false) : null,
  }
}

function montarItem(item) {
  return {
    id: item.id,
    item_name: limparTexto(item.item_name),
    field_type: item.field_type,
    options: item.field_type === 'dropdown' ? montarOpcoes(item.options, true) : null,
    success_value: item.field_type === 'checkbox' ? item.success_value !== false : null,
  }
}

function montarObservacoes(observacoes) {
  return { enabled: !!observacoes.enabled, label: limparTexto(observacoes.label) }
}

export function montarPayload(checklist) {
  const orientacoes = etapa =>
    etapa.instructions && etapa.instructions.trim() ? etapa.instructions.trim() : null

  return {
    id: checklist.id || undefined,
    checklist_code: limparTexto(checklist.checklist_code),
    title: limparTexto(checklist.title),
    reviewed_at: formatarDataPayload(checklist.reviewed_at),
    actived: !!checklist.actived,
    schema_version: SCHEMA_VERSION,
    header: checklist.header.map(montarCampo),
    body: checklist.body.map(etapa => ({
      id: etapa.id,
      step_name: limparTexto(etapa.step_name),
      instructions: orientacoes(etapa),
      groups: etapa.groups.map(grupo => ({
        id: grupo.id,
        group_name: limparTexto(grupo.group_name),
        items: grupo.items.map(montarItem),
      })),
    })),
    observations: montarObservacoes(checklist.observations),
    item_observations: montarObservacoes(checklist.item_observations),
    footer: checklist.footer.map(montarCampo),
  }
}

function mensagem(caminho, texto) {
  return caminho ? `${caminho}: ${texto}` : `${texto.charAt(0).toUpperCase()}${texto.slice(1)}`
}

function validarTexto(valor, caminho, descricao, maximo, obrigatorio = true) {
  if (!valor) return obrigatorio ? mensagem(caminho, `informe ${descricao}`) : null
  if (valor.length > maximo) {
    return mensagem(caminho, `${descricao} deve ter no máximo ${maximo} caracteres`)
  }
  if (CARACTERE_NAO_SUPORTADO.test(valor)) {
    return mensagem(caminho, `${descricao} contém caracteres não suportados (emojis)`)
  }
  return null
}

function validarOpcoes(opcoes, caminho, comResultado) {
  if (!opcoes || opcoes.length < LIMITES.minOpcoes) {
    return mensagem(caminho, `informe pelo menos ${LIMITES.minOpcoes} opções`)
  }
  if (opcoes.length > LIMITES.maxOpcoes) {
    return mensagem(caminho, `informe no máximo ${LIMITES.maxOpcoes} opções`)
  }

  const labels = []
  for (let indice = 0; indice < opcoes.length; indice++) {
    const opcao = opcoes[indice]
    const caminhoOpcao = `${caminho} > Opção ${indice + 1}`

    const erro = validarTexto(opcao.label, caminhoOpcao, 'o texto da opção', LIMITES.rotulo)
    if (erro) return erro

    if (labels.includes(opcao.label.toLowerCase())) {
      return mensagem(caminho, `a opção "${opcao.label}" está repetida`)
    }
    labels.push(opcao.label.toLowerCase())

    if (comResultado && !RESULTADOS.some(resultado => resultado.value === opcao.result)) {
      return mensagem(caminhoOpcao, 'selecione a classificação da resposta')
    }
  }
  return null
}

function validarCampos(campos, secao) {
  if (campos.length > LIMITES.campos) {
    return mensagem(secao, `informe no máximo ${LIMITES.campos} campos`)
  }

  for (let indice = 0; indice < campos.length; indice++) {
    const campo = campos[indice]
    const caminho = `${secao} > Campo ${indice + 1}`

    const erro = validarTexto(campo.label, caminho, 'o rótulo do campo', LIMITES.rotulo)
    if (erro) return erro

    if (!FIELD_TYPES.some(tipo => tipo.value === campo.field_type)) {
      return mensagem(caminho, 'selecione o tipo de campo')
    }
    if (campo.options) {
      const erroOpcoes = validarOpcoes(campo.options, caminho, false)
      if (erroOpcoes) return erroOpcoes
    }
  }
  return null
}

function validarItem(item, caminho) {
  const erro = validarTexto(item.item_name, caminho, 'a descrição do item', LIMITES.descricaoItem)
  if (erro) return erro

  if (!FIELD_TYPES.some(tipo => tipo.value === item.field_type)) {
    return mensagem(caminho, 'selecione o tipo de campo')
  }
  if (item.field_type === 'dropdown') return validarOpcoes(item.options, caminho, true)

  return null
}

function validarGrupo(grupo, caminho) {
  const erro = validarTexto(grupo.group_name, caminho, 'o nome do grupo', LIMITES.nome)
  if (erro) return erro

  if (!grupo.items.length) return mensagem(caminho, 'adicione pelo menos um item de avaliação')
  if (grupo.items.length > LIMITES.itensPorGrupo) {
    return mensagem(caminho, `informe no máximo ${LIMITES.itensPorGrupo} itens de avaliação`)
  }

  for (let indice = 0; indice < grupo.items.length; indice++) {
    const erroItem = validarItem(grupo.items[indice], `${caminho} > Item ${indice + 1}`)
    if (erroItem) return erroItem
  }
  return null
}

function validarEtapa(etapa, caminho) {
  const erro =
    validarTexto(etapa.step_name, caminho, 'o nome da etapa', LIMITES.nome) ||
    validarTexto(
      etapa.instructions,
      caminho,
      'o texto de orientações da etapa',
      LIMITES.orientacoes,
      false,
    )
  if (erro) return erro

  if (!etapa.groups.length) return mensagem(caminho, 'adicione pelo menos um grupo de itens')
  if (etapa.groups.length > LIMITES.grupos) {
    return mensagem(caminho, `informe no máximo ${LIMITES.grupos} grupos de itens`)
  }

  for (let indice = 0; indice < etapa.groups.length; indice++) {
    const erroGrupo = validarGrupo(etapa.groups[indice], `${caminho} > Grupo ${indice + 1}`)
    if (erroGrupo) return erroGrupo
  }
  return null
}

function validarObservacoes(observacoes, descricao) {
  if (!observacoes.enabled && !observacoes.label) return null
  return validarTexto(observacoes.label, '', descricao, LIMITES.rotulo)
}

export function validarChecklist(checklist) {
  const payload = montarPayload(checklist)

  const erroIdentificacao =
    validarTexto(payload.checklist_code, '', 'o código do checklist', LIMITES.codigo) ||
    validarTexto(payload.title, '', 'o título do checklist', LIMITES.titulo)
  if (erroIdentificacao) return erroIdentificacao

  if (payload.reviewed_at && !/^\d{4}-\d{2}-\d{2}$/.test(payload.reviewed_at)) {
    return 'Informe uma data de revisão válida (dd/mm/aaaa)'
  }

  const erroCabecalho = validarCampos(payload.header, 'Cabeçalho')
  if (erroCabecalho) return erroCabecalho

  if (!payload.body.length) return 'O checklist deve ter pelo menos uma etapa'
  if (payload.body.length > LIMITES.etapas) {
    return `O checklist deve ter no máximo ${LIMITES.etapas} etapas`
  }

  for (let indice = 0; indice < payload.body.length; indice++) {
    const erroEtapa = validarEtapa(payload.body[indice], `Etapa ${indice + 1}`)
    if (erroEtapa) return erroEtapa
  }

  if (contarItens(payload) > LIMITES.itens) {
    return `O checklist deve ter no máximo ${LIMITES.itens} itens de avaliação`
  }

  return (
    validarObservacoes(payload.observations, 'o rótulo das observações gerais') ||
    validarObservacoes(payload.item_observations, 'o rótulo da observação por item') ||
    validarCampos(payload.footer, 'Rodapé')
  )
}

function limitar(texto, maximo) {
  return texto.length > maximo ? texto.slice(0, maximo) : texto
}

function duplicarCampo(campo) {
  return {
    ...campo,
    id: gerarId('f'),
    options: campo.options ? campo.options.map(opcao => novaOpcao(opcao.label)) : null,
  }
}

export function duplicarChecklist(doc) {
  const checklist = parseChecklist(doc)

  return {
    ...checklist,
    id: null,
    checklist_code: limitar(`${checklist.checklist_code}-COPIA`, LIMITES.codigo),
    title: limitar(`Cópia de ${checklist.title}`, LIMITES.titulo),
    reviewed_at: null,
    created_at: null,
    actived: true,
    header: checklist.header.map(duplicarCampo),
    body: checklist.body.map(etapa => ({
      ...etapa,
      id: gerarId('s'),
      groups: etapa.groups.map(grupo => ({
        ...grupo,
        id: gerarId('g'),
        items: grupo.items.map(duplicarItem),
      })),
    })),
    footer: checklist.footer.map(duplicarCampo),
  }
}
